import { Component, OnDestroy, OnInit, ViewContainerRef } from '@angular/core';

import { Router } from '@angular/router';
import { firstValueFrom, retry } from 'rxjs';
import {
  formatDateTimeStamp,
  getFormattedDate,
  getFormattedDateTime,
  isLargeScreen,
} from '../../../../../global.variable';
import { AppService } from '../../../../app.service';
import { MediaPreviewComponent } from '../../../../shared/components/media-preview/media-preview.component';
import { ModalDialogueService } from '../../../../shared/components/modal-dialogue/modal-dialogue.service';
import { ViewUserDetailComponent } from '../../../../shared/components/view-user-detail/view-user-detail.component';
import { LoadingSpinnerService } from '../../../../shared/services/loading-spinner.service';
import { ToasterService } from '../../../../shared/services/toaster.service';
import { WebSocketService } from '../../../../shared/services/web-socket.service';
import { UsersService } from '../../users/users.service';
import { ConfirmDialogComponent } from '../../../../shared/components/confirm-dialog/confirm-dialog.component';
import { JobsService } from '../../jobs/jobs.service';
import { formatDate } from '@angular/common';

@Component({
  selector: 'gtapp-time-attendance-report',
  templateUrl: './time-attendance-report.html',
  styleUrl: './time-attendance-report.scss',
  standalone: false,
})
export class TimeAttendanceReport implements OnInit, OnDestroy {
  largeView = isLargeScreen;
  webSocketSubscription: any;

  previousClockInOutTimeSheet: number = 0;
  rowsClockInOutTimeSheet: number = this.largeView ? 10 : 5;
  pageNumClockInOutTimeSheet: number = 1;
  totalPagesClockInOutTimeSheet: number = 0;
  totalRowsClockInOutTimeSheet: number = 0;

  sortKeyClockInOutTimeSheet: any = ['shift_start', 'shift_name', 'updated_at'];
  searchParamsClockInOutTimeSheet: any;

  clockInOutTimeSheetData: any = [];
  otherParamsClockInOutTimeSheet: any = {
    apiFiltering: true,
    hideHeaders: !this.largeView,
  };

  selectedDate = getFormattedDate();
  nextMonday = getFormattedDate();
  currentMonday = this.getCurrentMonday();

  selectedWeekEnd = getFormattedDate();

  selectedTimeSheetData: any = {};
  clockInOutTimeSheetTableInfo: any = [];

  userDetailPopoverTemplate = ViewUserDetailComponent;

  pendingClockOutTableDurationTimer: any;
  pendingClockOutSelectedDurationTimer: any;

  maxClockOutDurationAllowed: number = 1000 * 60 * 60 * 24; // 24 hrs

  userLookupDataList: any = [];
  selectedUser: any = {};
  initialDataList = { user: [], shift: [] };
  shiftSearchString: string = '';
  shiftLookupDataList: any = [];
  selectedJobType: any = {};
  availableJobTypes: any = [];

  constructor(
    private dialogService: ModalDialogueService,
    private spinnerService: LoadingSpinnerService,
    private viewContainerRef: ViewContainerRef,
    private toasterService: ToasterService,
    private userService: UsersService,
    private router: Router,
    private webSocketService: WebSocketService,
    private appService: AppService,
    private jobService: JobsService,
  ) {}
  ngOnDestroy(): void {
    if (this.webSocketSubscription) this.webSocketSubscription?.unsubscribe();
    if (this.pendingClockOutTableDurationTimer) {
      clearInterval(this.pendingClockOutTableDurationTimer);
    }
    if (this.pendingClockOutSelectedDurationTimer) {
      clearInterval(this.pendingClockOutSelectedDurationTimer);
    }
  }
  ngOnInit(): void {
    let selectedFilters: any = sessionStorage.getItem(
      btoa('clockInOutReportFilters'),
    );

    if (selectedFilters) {
      selectedFilters = JSON.parse(selectedFilters);
      const date = selectedFilters?.selectedDate
        ? new Date(selectedFilters?.selectedDate)
        : new Date();
      this.getMonday(date);
      this.selectedUser = selectedFilters?.selectedUser || {};
      this.shiftSearchString = selectedFilters?.shiftSearchString || '';
      this.selectedJobType = selectedFilters?.selectedJobType || {};
      this.previousClockInOutTimeSheet =
        selectedFilters?.previousClockInOutTimeSheet || 0;
      this.rowsClockInOutTimeSheet =
        selectedFilters?.rowsClockInOutTimeSheet || this.largeView ? 10 : 5;
      this.pageNumClockInOutTimeSheet =
        selectedFilters?.pageNumClockInOutTimeSheet || 1;
    }
    if (!this.selectedDate) {
      this.getMonday();
    }
    this.getWeekEndDate();
    this.getAllPossibleJobTypes();

    this.getTableDetails();
    this.onSearchUsers();
    this.spinnerService.show('Fetching Data');
    this.getAllClockInOutReportData();
    this.webSocketSubscription =
      this.webSocketService.webSocketSubject.subscribe((event: any) => {
        if (
          ['wsn_user_clock_out', 'wsn_user_clock_in'].includes(event?.event) &&
          this.pageNumClockInOutTimeSheet === 1 &&
          this.currentMonday == this.selectedDate
        ) {
          setTimeout(() => {
            this.getAllClockInOutReportData();
          }, 1000);
        }
      });
  }
  getAllPossibleJobTypes() {
    let subscriberStats = JSON.parse(
      localStorage.getItem('subscriberStats') || '{}',
    );

    this.jobService.getJobParams().subscribe((response: any) => {
      const filteredJobTypes = (response?.data || [])?.filter(
        (_type: any) =>
          ![0, 5].includes(_type?.type_identity) &&
          (_type?.type_identity === 4
            ? subscriberStats.checkpoint_count > 0
            : true),
      );
      this.availableJobTypes = filteredJobTypes;
    });
  }
  getWeekEndDate() {
    const weekEnd = new Date(this.selectedDate);
    weekEnd.setDate(weekEnd.getDate() + 6);

    this.selectedWeekEnd = getFormattedDate(weekEnd);
  }
  getMonday(date: Date = new Date()) {
    const monday = new Date(date);
    const day = monday.getDay(); // 0 = Sun

    const diff = day === 0 ? -6 : 1 - day;
    monday.setDate(monday.getDate() + diff);

    this.selectedDate = getFormattedDate(monday);
  }
  getCurrentMonday() {
    const monday = new Date();
    const day = monday.getDay(); // 0 = Sun

    const diff = day === 0 ? -6 : 1 - day;
    monday.setDate(monday.getDate() + diff);

    const currentMonday = getFormattedDate(monday);

    this.nextMonday = getFormattedDate(
      new Date(new Date(monday).getTime() + 1000 * 60 * 60 * 24 * 6),
    );

    return currentMonday;
  }

  onOpenFile(fileUrl: any) {
    this.dialogService.open(
      MediaPreviewComponent,
      {
        data: { mediaSrc: fileUrl },
      },
      this.viewContainerRef,
    );
  }

  openClockInOutDetailedTemplate(template: any) {
    const dialogRef = this.dialogService.open(
      template,
      {},
      this.viewContainerRef,
    );
    dialogRef.afterClosed().subscribe((res: any) => {
      if (this.pendingClockOutSelectedDurationTimer) {
        clearInterval(this.pendingClockOutSelectedDurationTimer);
      }
      if (res?.id) {
        if (res?.job_type_key == 4) {
          this.router.navigate([
            '/view-route',
            {
              rKey: String(res?.id),
            },
          ]);
        } else if (res?.job_type_key == -1) {
          this.router.navigate([
            '/view-runsheet',
            {
              rKey: String(res?.id),
            },
          ]);
        } else {
          this.router.navigate([`/job-detail/JOBID`], {
            queryParams: { jId: res?.id },
          });
        }
      }
    });
  }
  getClockInOutDetails(eventData: any, template: any) {
    this.selectedTimeSheetData = {};

    let reqBody: any = {
      clock_in_id: eventData?.clock_in_id,
      clock_out_id: eventData?.clock_out_id,
      sub_user_id: eventData?.subs_user_id,
      user_name: eventData?.user_name,
      job_id: eventData?.job_data?.id,
      runsheet_id: eventData?.runsheet_data?.id,
      patrol_id: eventData?.patrol_route_data?.id,
    };

    this.selectedTimeSheetData = {
      duration: eventData?.session_duration,
      subs_user_id: eventData?.subs_user_id,
      user_name: eventData?.user_name,
      job_id: eventData?.job_data?.id,
      runsheet_id: eventData?.runsheet_data?.id,
      patrol_id: eventData?.patrol_route_data?.id,
      additional_info: eventData?.additional_info,
    };

    this.openClockInOutDetailedTemplate(template);

    this.spinnerService.show('Fetching Data');
    this.userService
      .modfiyTimeAttendanceReport(reqBody, { timesheet_detail: 1 })
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.selectedTimeSheetData = {
            ...eventData,
            ...response?.data,
            duration: eventData?.session_duration,
            subs_user_id: eventData?.subs_user_id,
            user_name: eventData?.user_name,
            job_id: eventData?.job_data?.id,
            runsheet_id: eventData?.runsheet_data?.id,
            patrol_id: eventData?.patrol_route_data?.id,
            additional_info: eventData?.additional_info,
          };

          this.durationTimerCheck();

          this.spinnerService.hide();
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
          this.spinnerService.hide();
        }
      });
  }
  getAllClockInOutReportDataCount(body: any) {
    this.userService
      .modfiyTimeAttendanceReport(body, { get_count: 1 })
      .subscribe((response: any) => {
        this.totalRowsClockInOutTimeSheet = response?.total_size;
        this.totalPagesClockInOutTimeSheet = Math.ceil(
          this.totalRowsClockInOutTimeSheet / this.rowsClockInOutTimeSheet,
        );
        this.otherParamsClockInOutTimeSheet.paginationData = {
          totalRows: this.totalRowsClockInOutTimeSheet,
          previousRows: this.previousClockInOutTimeSheet,
          rows: this.rowsClockInOutTimeSheet,
          pageNum: this.pageNumClockInOutTimeSheet,
          totalPages: this.totalPagesClockInOutTimeSheet,
        };
        this.otherParamsClockInOutTimeSheet = {
          ...this.otherParamsClockInOutTimeSheet,
        };

        sessionStorage.setItem(
          btoa('clockInOutReportFilters'),
          JSON.stringify({
            selectedDate: this.selectedDate,
            selectedUser: this.selectedUser,
            shiftSearchString: this.shiftSearchString,
            selectedJobType: this.selectedJobType,
            previousClockInOutTimeSheet: this.previousClockInOutTimeSheet || 0,
            rowsClockInOutTimeSheet:
              this.rowsClockInOutTimeSheet || this.largeView ? 2 : 5,
            pageNumClockInOutTimeSheet: this.pageNumClockInOutTimeSheet || 1,
          }),
        );
      });
  }
  getWeekDateRangeDict() {
    return {
      start: formatDate(new Date(this.selectedDate), 'yyyy-MM-dd', 'en_US'),
      end: formatDate(new Date(this.selectedWeekEnd), 'yyyy-MM-dd', 'en_US'),
    };
  }
  getAllClockInOutReportData(getCount = true) {
    let reqBody: any = {
      rows: 20,
      date_range: this.getWeekDateRangeDict(),
    };
    this.searchParamsClockInOutTimeSheet = {
      ...(this.searchParamsClockInOutTimeSheet || {}),
      shift_name: this.shiftSearchString,
    };
    if (
      !this.shiftSearchString &&
      this.searchParamsClockInOutTimeSheet &&
      'shift_name' in this.searchParamsClockInOutTimeSheet
    ) {
      delete this.searchParamsClockInOutTimeSheet?.shift_name;
    }

    if (this.rowsClockInOutTimeSheet) {
      reqBody['rows'] = this.rowsClockInOutTimeSheet;
    }
    if (this.previousClockInOutTimeSheet) {
      reqBody['previous'] = this.previousClockInOutTimeSheet;
    }
    if (this.sortKeyClockInOutTimeSheet) {
      reqBody['sort_key'] = this.sortKeyClockInOutTimeSheet;
    }
    if (this.searchParamsClockInOutTimeSheet) {
      reqBody['timesheet_search_params'] = this.searchParamsClockInOutTimeSheet;
    }
    if (this.selectedUser?.id) {
      reqBody['sub_user_id'] = this.selectedUser?.id;
    }
    if (this.selectedJobType?.id) {
      reqBody['job_type_id'] = this.getPayloadJobTypeId();
    }
    if (getCount) this.getAllClockInOutReportDataCount(reqBody);
    this.userService
      .modfiyTimeAttendanceReport(reqBody)
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.spinnerService.hide();

          this.clockInOutTimeSheetData = response?.data;
          this.durationTimerCheck('table');
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
          this.spinnerService.hide();
        }
      });
  }
  onChangePaginationTimeSheetLog(data: any) {
    this.previousClockInOutTimeSheet =
      data?.paginationData?.previousRows || data?.previous || 0;
    this.pageNumClockInOutTimeSheet =
      data?.paginationData?.pageNum || data?.pageNum;

    const getCount = !!(
      this.rowsClockInOutTimeSheet != data?.paginationData?.rows ||
      data?.pageSize
    );
    this.rowsClockInOutTimeSheet = data?.paginationData?.rows || data?.pageSize;

    this.otherParamsClockInOutTimeSheet.paginationData = {
      ...data?.paginationData,
    };

    this.getAllClockInOutReportData(getCount);
  }
  sortColumnTimeSheetLog(body: any) {
    this.sortKeyClockInOutTimeSheet = body?.sortList || [];
    this.searchParamsClockInOutTimeSheet = body?.searchParams || {};
    this.getAllClockInOutReportData(false);
  }
  changeWeek(operation: '-' | '+' | 'today') {
    const selectedDay = this.selectedDate
      ? new Date(this.selectedDate)
      : new Date();
    selectedDay.setHours(0, 0, 0, 0);

    const week = 1000 * 60 * 60 * 24 * 7;
    if (operation == '-') {
      this.selectedDate = getFormattedDate(
        new Date(selectedDay.getTime() - week),
      );
    } else if (operation == '+') {
      this.selectedDate = getFormattedDate(
        new Date(selectedDay.getTime() + week),
      );
    } else {
      this.getMonday(new Date(getFormattedDate()));
    }

    this.onSelectedDateChange();
  }
  onSelectedDateChange() {
    if (this.selectedDate) {
      this.getMonday(new Date(this.selectedDate));
    } else {
      setTimeout(() => {
        this.getMonday();
      }, 10);
    }

    this.getWeekEndDate();
    this.previousClockInOutTimeSheet = 0;
    this.pageNumClockInOutTimeSheet = 1;

    this.getAllClockInOutReportData();
    this.initialDataList['shift'] = [];
    this.shiftLookupDataList = [];
  }

  searchColumnTimeSheetLog(event: any) {
    this.previousClockInOutTimeSheet = 0;
    this.pageNumClockInOutTimeSheet = 1;

    this.searchParamsClockInOutTimeSheet = event?.searchParams || {};

    this.getAllClockInOutReportData();
  }
  durationTimerCheck(source = 'individual') {
    if (source === 'table') {
      const isTherePendingClockOuts = this.clockInOutTimeSheetData?.some(
        (job: any) =>
          !job?.clocked_out_at &&
          new Date().getTime() - new Date(job?.clocked_in_at).getTime() <
            this.maxClockOutDurationAllowed,
      );

      if (isTherePendingClockOuts) {
        this.pendingClockOutTableDurationTimer = setInterval(() => {
          this.otherParamsClockInOutTimeSheet = JSON.parse(
            JSON.stringify(this.otherParamsClockInOutTimeSheet),
          );
        }, 1000);
      } else if (this.pendingClockOutTableDurationTimer) {
        clearInterval(this.pendingClockOutTableDurationTimer);
      }
    } else {
      if (this.selectedTimeSheetData?.clock_out_data?.updated_at) {
        this.selectedTimeSheetData.duration =
          this.selectedTimeSheetData?.session_duration;
      } else {
        const duration = this.getDuration(
          this.selectedTimeSheetData?.clock_in_data?.updated_at,
        );
        this.selectedTimeSheetData.duration = duration;
        if (duration && duration != 'DNC') {
          this.pendingClockOutSelectedDurationTimer = setInterval(() => {
            this.selectedTimeSheetData.duration = this.getDuration(
              this.selectedTimeSheetData?.clock_in_data?.updated_at,
            );
          }, 1000);
        } else if (this.pendingClockOutSelectedDurationTimer) {
          clearInterval(this.pendingClockOutSelectedDurationTimer);
        }
      }
    }
  }
  getSessionDuration(rowData: any) {
    if (rowData?.clocked_out_at) return rowData?.session_duration;
    return this.getDuration(rowData?.clocked_in_at);
  }

  getDuration(clockInTime: any) {
    const diffInTime = new Date().getTime() - new Date(clockInTime).getTime();
    function pad(n: number): string {
      return n.toString().padStart(2, '0');
    }
    if (diffInTime == null) {
      return null;
    }
    if (diffInTime > this.maxClockOutDurationAllowed)
      return 'Did Not Clock Out (DNC)';

    const totalSeconds = Math.floor(diffInTime / 1000);

    if (totalSeconds <= 0) {
      return '00:00:00';
    }

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  }
  async onActionClick(
    clockOutTemplate: any,
    noteTemplate: any,
    event: any,
    eventDetailTemplate: any,
    menuOptionTemplate: any,
    modifyClockInOutTemplate: any,
  ) {
    const eventData = event?.event;

    switch (event?.type) {
      case 'invoice_id':
        this.router.navigate([
          '/print-invoice',
          { invKey: btoa(String(eventData?.job_data?.invoice_data?.id)) },
        ]);
        break;
      case 'approve':
        this.spinnerService.show('Approving');

        this.updateTimeSheetData(
          {
            clock_in_id: eventData?.clock_in_id,
            clock_out_id: eventData?.clock_out_id,
            sub_user_id: eventData?.subs_user_id,
            approved: true,
          },
          { timesheet_update: 1 },
        );
        break;
      case 'reject':
        this.spinnerService.show('Rejecting');

        this.updateTimeSheetData(
          {
            event_type: '',
            clock_in_id: eventData?.clock_in_id,
            clock_out_id: eventData?.clock_out_id,
            sub_user_id: eventData?.subs_user_id,
            rejected: true,
          },
          { timesheet_update: 1 },
        );
        break;
      case 'accept_reject':
        const confirmDialogRef = this.dialogService.open(
          ConfirmDialogComponent,
          {
            data: {
              // title: 'Are you sure?',
              message: `Reset status`,

              btn2Detail: { text: 'OK' },
            },
          },
        );
        const confirmDialogRefResponse = await firstValueFrom(
          confirmDialogRef.afterClosed(),
        );
        if (confirmDialogRefResponse == true) {
          this.spinnerService.show('Resetting');

          this.updateTimeSheetData(
            {
              clock_in_id: eventData?.clock_in_id,
              clock_out_id: eventData?.clock_out_id,
              sub_user_id: eventData?.subs_user_id,
              reset: true,
            },
            { timesheet_update: 1 },
          );
        }

        break;
      case 'show_details':
        const menuDialogRef = this.dialogService.open(
          menuOptionTemplate,
          { data: eventData },
          this.viewContainerRef,
        );

        const dRes = await firstValueFrom(menuDialogRef.afterClosed());
        if (!dRes) return;
        if (dRes == 'show_details') {
          this.getClockInOutDetails(eventData, eventDetailTemplate);
        } else {
          this.onActionClick(
            clockOutTemplate,
            noteTemplate,
            { event: eventData, type: dRes },
            eventDetailTemplate,
            menuOptionTemplate,
            modifyClockInOutTemplate,
          );
        }

        break;

      case 'clock_out':
        this.onManualClockOut(eventData, clockOutTemplate);
        break;
      case 'update_note':
        const dialogRef = this.dialogService.open(
          noteTemplate,
          {
            data: {
              notes: eventData?.additional_info?.clock_report?.notes || '',
              oldValue: eventData?.additional_info?.clock_report?.notes,
            },
          },
          this.viewContainerRef,
        );

        const dialogResponse = await firstValueFrom(dialogRef.afterClosed());

        if (dialogResponse && 'notes' in dialogResponse) {
          this.spinnerService.show('Updating Notes');
          let reqBody: any = {
            clock_in_id: eventData?.clock_in_id,
            clock_out_id: eventData?.clock_out_id,
            sub_user_id: eventData?.subs_user_id,
            notes: dialogResponse?.notes,
          };
          this.updateTimeSheetData(reqBody, { timesheet_update: 1 });
        }

        break;
      case 'update_clock_in_time':
        const cInDialogRef = this.dialogService.open(
          modifyClockInOutTemplate,
          {
            data: {
              newValue: getFormattedDateTime(eventData?.clocked_in_at),
              oldValue: getFormattedDateTime(eventData?.clocked_in_at),
              clock_in_id: eventData?.clock_in_id,
              clock_in_event_action: eventData?.clock_in_event_action,
              start_datetime:
                eventData?.job_data?.start_datetime ||
                eventData?.runsheet_data?.start_datetime ||
                eventData?.patrol_route_data?.start_datetime,
            },
          },
          this.viewContainerRef,
        );

        const dRes2 = await firstValueFrom(cInDialogRef.afterClosed());

        if (dRes2) {
          this.spinnerService.show('Updating Clock In Time');
          let reqBody: any = {
            clock_in_id: eventData?.clock_in_id,
            updated_clocked_in_at: new Date(dRes2?.newValue),
            sub_user_id: eventData?.subs_user_id,
            reason: dRes2?.reason,
          };

          if (
            dRes2?.valueChanged &&
            [5, 0, 4, 1].includes(eventData?.clock_in_event_action)
          ) {
            reqBody.updated_clocked_in_event_action =
              dRes2?.updated_clocked_in_event_action;
          }

          this.updateTimeSheetData(reqBody, { timesheet_update: 1 });
        }

        break;
      case 'update_clock_out_time':
        const cOutDialogRef = this.dialogService.open(
          modifyClockInOutTemplate,
          {
            data: {
              newValue: getFormattedDateTime(eventData?.clocked_out_at),
              oldValue: getFormattedDateTime(eventData?.clocked_out_at),
              clock_out_event_action: eventData?.clock_out_event_action,
              end_datetime:
                eventData?.job_data?.end_datetime ||
                eventData?.runsheet_data?.end_datetime ||
                eventData?.patrol_route_data?.end_datetime,
            },
          },
          this.viewContainerRef,
        );

        const dRes3 = await firstValueFrom(cOutDialogRef.afterClosed());

        if (dRes3) {
          this.spinnerService.show('Updating Clock Out Time');
          let reqBody: any = {
            clock_in_id: eventData?.clock_in_id,
            clock_out_id: eventData?.clock_out_id,
            sub_user_id: eventData?.subs_user_id,
            updated_clocked_out_at: new Date(dRes3?.newValue),
            reason: dRes3?.reason,
          };
          if (
            dRes3?.valueChanged &&
            [5, 0, 4, 1].includes(eventData?.clock_out_event_action)
          ) {
            reqBody.updated_clocked_out_event_action =
              dRes3?.updated_clocked_out_event_action;
          }

          this.updateTimeSheetData(reqBody, { timesheet_update: 1 });
        }

        break;
    }
  }
  updateTimeSheetData(reqBody: any, params: any) {
    this.userService
      .modfiyTimeAttendanceReport(reqBody, params)
      .subscribe((response: any) => {
        if (response?.status !== 'success') {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response?.message,
          });
          this.spinnerService.hide();
          return;
        }
        setTimeout(() => {
          this.getAllClockInOutReportData();
        }, 500);
      });
  }

  onManualClockOut(eventData: any, template: any) {
    const minVal = new Date(eventData?.clocked_in_at).getTime() + 1000 * 60;
    const dialogRef = this.dialogService.open(
      template,
      {
        data: {
          minVal: getFormattedDateTime(minVal),
          clock_out_time: getFormattedDateTime(
            Math.max(minVal, new Date().getTime()),
          ),
        },
      },
      this.viewContainerRef,
    );
    dialogRef.afterClosed().subscribe((res: any) => {
      if (res) {
        let fileData: FormData = new FormData();
        this.spinnerService.show('Clocking Out');

        let params: any = { clock_out: 1 };
        let reasonDict: any = {
          reason: res?.reason,
          proxyClockOut: new Date(res?.clock_out_time),
        };

        if (eventData?.job_id || eventData?.job_data?.id)
          reasonDict['jobId'] = eventData?.job_id || eventData?.job_data?.id;

        if (eventData?.patrol_id || eventData?.patrol_route_data?.id)
          reasonDict['cPatrolId'] =
            eventData?.patrol_id || eventData?.patrol_route_id;

        if (eventData?.runsheet_id || eventData?.runsheet_data?.id)
          reasonDict['runsheetId'] =
            eventData?.runsheet_id || eventData?.runsheet_data?.id;

        fileData.append('reason_dict', JSON.stringify(reasonDict));
        fileData.append('subs_user_id', eventData?.subs_user_id);

        this.appService
          .formDataApi(`profile/clock_user`, fileData, false, params)
          .then((response: any) => {
            if (response?.status == 'success') {
              setTimeout(() => {
                this.getAllClockInOutReportData();
              }, 500);
            } else {
              this.spinnerService.hide();
              this.toasterService.setMessage({
                successMessage: '',
                errorMessage: response?.message,
                timeOut: 5000,
              });
            }
          });
      }
    });
  }
  clearAndFocusTextBox(elementId: string) {
    setTimeout(() => {
      var element = <HTMLInputElement>document.getElementById(elementId);
      element?.focus();
    }, 100);
  }
  getTableDetails() {
    this.clockInOutTimeSheetTableInfo = [
      {
        header: 'Date',
        sortKey: 'shift_start',
        sortOrder: 'asc',
        nestedValue: (row: any) => {
          return formatDateTimeStamp(row?.shift_start, 'EEE d MMM y', 'en_US');
        },
      },

      {
        header: 'Scheduled',

        nestedValue: (row: any) => {
          const startTime =
            row?.job_data?.start_datetime ||
            row?.runsheet_data?.start_datetime ||
            row?.patrol_route_data?.start_datetime;

          const endTime =
            row?.job_data?.end_datetime ||
            row?.runsheet_data?.end_datetime ||
            row?.patrol_route_data?.end_datetime;

          const eventDay = this.getOnlyDateFromDateObj(row?.shift_start);

          return startTime && endTime
            ? `Start: ${formatDateTimeStamp(startTime, 'HH:mm', 'en_US')} \n End: ${this.getDateTimeWithSameDayCheck(eventDay, endTime)}`
            : null;
        },
        conditionalColumnStyle: (row: any) => {
          return row?.failed_event_id
            ? {
                'color': 'var(--bs-danger)',
                'white-space': 'pre-line',
                'font-size': '0.8rem',
                'font-family': 'Roboto Mono',
                'text-align': 'end',
              }
            : {
                'white-space': 'pre-line',
                'font-size': '0.8rem',
                'font-family': 'Roboto Mono',
                'text-align': 'end',
              };
        },
        suffixNestedValue: (row: any) => {
          const shiftDuration =
            row?.job_data?.shift_duration ||
            row?.runsheet_data?.shift_duration ||
            row?.patrol_route_data?.shift_duration;

          return shiftDuration ? `\nDur: ${shiftDuration}` : null;
        },
        suffixStyle: {
          'white-space': 'pre-line',
          'font-size': '0.8rem',
          'font-family': 'Roboto Mono',
          'text-align': 'end',
        },
      },

      {
        header: 'Clock In - Out',
        showAction: true,
        conditionalColumnStyle: (row: any) => {
          return {};
        },

        actionOptions: [
          {
            conditionalActionStyle: (row: any) => {
              if (row?.clock_in_event_action == 5) {
                return {
                  'color': '#ff0000',
                  'display': 'block',
                  'width': 'fit-content',
                  'font-size': '0.8rem',
                  'font-family': 'Roboto Mono',
                  'text-align': 'end',
                };
              }
              return {
                'display': 'block',
                'width': 'fit-content',
                'font-size': '0.8rem',
                'font-family': 'Roboto Mono',
                'text-align': 'end',
              };
            },

            condition: (row: any) => {
              const eventDay = this.getOnlyDateFromDateObj(row?.shift_start);
              let returnString = `In : ${this.getDateTimeWithSameDayCheck(
                eventDay,
                row?.clocked_in_at,
              )}`;
              if (row?.clock_in_event_action == 5) {
                returnString += ' [LATE CLOCK IN]';
              }

              return {
                value: returnString,
              };
            },
          },
          {
            conditionalActionStyle: (row: any) => {
              if ([4, 7].includes(row?.clock_out_event_action)) {
                return {
                  'color': '#ff0000',
                  'display': 'block',
                  'width': 'fit-content',
                  'font-size': '0.8rem',
                  'font-family': 'Roboto Mono',
                  'text-align': 'end',
                };
              }
              return {
                'display': 'block',
                'width': 'fit-content',
                'font-size': '0.8rem',
                'font-family': 'Roboto Mono',
                'text-align': 'end',
              };
            },

            condition: (row: any) => {
              let returnString = '';
              if (row?.clocked_out_at) {
                const eventDay = this.getOnlyDateFromDateObj(row?.shift_start);
                returnString += ` \nOut: ${this.getDateTimeWithSameDayCheck(eventDay, row?.clocked_out_at)}`;
                if (row?.clock_out_event_action == 4) {
                  returnString += ' [EARLY CLOCK OUT]';
                }
                if (row?.clock_out_event_action == 7) {
                  returnString += ' [FORCED CLOCK OUT]';
                }
              }

              return {
                value: returnString,
              };
            },
          },
          {
            conditionalActionStyle: (row: any) => {
              if (!row?.clocked_out_at)
                return {
                  'color': 'var(--bs-danger)',
                  'font-weight': 500,
                  'display': 'block',
                  'width': 'fit-content',
                  'font-size': '0.8rem',
                  'font-family': 'Roboto Mono',
                  'text-align': 'end',
                };

              return {
                'display': 'block',
                'width': 'fit-content',
                'margin-bottom': '0.5rem',
                'font-size': '0.8rem',
                'font-family': 'Roboto Mono',
                'text-align': 'end',
              };
            },

            condition: (row: any) => {
              return {
                value: `\nDur: ${this.getSessionDuration(row)}`,
              };
            },
          },
          {
            actionStyle: {
              'padding': '0.2rem 0.4rem',
              'border-radius': '5px',
              'border': '1px solid #0dcaf0',
              'color': '#0dcaf0',
              'background': '#fff',
              'display': 'block',
              'font-size': 'smaller',
              'font-weight': '700',
              'width': 'fit-content',
            },
            role: 'button',

            condition: function (row: any) {
              if (row?.clocked_out_at) return;
              return {
                value: 'CLOCK OUT',
                confirm: true,
                type: 'clock_out',
                title: 'Clock Out',
              };
            },
          },
        ],
      },
      {
        header: 'Staff',
        name: 'user_name',
        sortKey: 'user_name',
        conditionalColumnStyle: (row: any) => {
          return row?.failed_event_id ? { color: 'var(--bs-danger)' } : {};
        },
      },
      {
        header: 'Site / Patrol',
        sortKey: 'shift_name',
        nestedValue: (row: any) => {
          const shiftName =
            (row?.job_data?.company_name
              ? `${row?.job_data?.company_name} - ` + row?.job_data?.site_name
              : row?.job_data?.site_name) ||
            row?.runsheet_data?.name ||
            row?.patrol_route_data?.name ||
            null;
          return shiftName;
        },
        suffixNestedValue: (row: any) => {
          const suffixList: any = [];
          const jobType = row?.job_data?.job_type_name
            ? `[${row?.job_data?.job_type_name}]`
            : row?.runsheet_data?.name
              ? '[Scheduled Patrol]'
              : row?.patrol_route_data?.name
                ? '[Checkpoint Patrol]'
                : null;
          if (row?.job_data?.site_address)
            suffixList.push(row?.job_data?.site_address);

          if (jobType) suffixList.push(jobType);

          if (suffixList?.length) suffixList.unshift('');

          return suffixList?.join('\n');
        },
        suffixStyle: {
          'font-size': 'small',
          'white-space': 'pre-line',
        },
        tableColumnStyle: {
          'white-space': 'pre-line',
        },
        conditionalColumnStyle: (row: any) => {
          return row?.failed_event_id ? { color: 'var(--bs-danger)' } : {};
        },
      },

      {
        header: 'Notes',
        showAction: true,
        nestedValue: (row: any) => {
          const notes = row?.additional_info?.clock_report?.notes;
          if (!notes) return null;
          return notes?.length > 100 ? notes?.slice(0, 100) + '...' : notes;
        },

        actionOptions: [
          {
            role: 'button',
            condition: function (row: any) {
              const invoiceData = row?.job_data?.invoice_data;
              if (!invoiceData) return;

              return {
                value: 'Inv ' + invoiceData?.invoice_id,
                type: 'invoice_id',
                valueClass:
                  'custom-button mb-3 d-block text-center fit-content',
              };
            },
          },

          {
            role: 'button',
            condition: function (row: any) {
              const notes = row?.additional_info?.clock_report?.notes;
              if (notes) {
                return {
                  type: 'update_note',
                  prefix:
                    notes?.length > 100 ? notes?.slice(0, 100) + '...' : notes,
                  prefixStyle: { 'font-size': 'small' },
                  title: 'Update Note',
                  icon: 'add-button ms-2 md-font-size',
                };
              }
              return {
                value: '',
                type: 'update_note',
                title: 'Update Note',
                icon: 'add-button ms-2 md-font-size',
              };
            },
          },
        ],
        tableColumnStyle: {
          // 'vertical-align': 'top',
        },
      },
      {
        header: '',
        showAction: true,

        actionOptions: [
          {
            condition: function (row: any) {
              const approved =
                row?.additional_info?.clock_report?.status == 'approved';
              const rejected =
                row?.additional_info?.clock_report?.status == 'rejected';

              if (approved || rejected) {
                if (approved) {
                  return {
                    value: 'Approved',
                    valueStyle: {
                      'padding': '0.2rem 0.4rem',
                      'border': '1px solid var(--bs-success)',
                      'border-radius': '5px',
                      'margin-bottom': '1rem',
                      'display': 'inline-block',
                      'text-align': 'center',
                      'color': 'var(--bs-light)',
                      'background': 'var(--bs-success)',
                      'font-size': 'smaller',
                    },
                  };
                } else {
                  return {
                    value: 'Rejected',
                    valueStyle: {
                      'padding': '0.2rem 0.4rem',
                      'border': '1px solid var(--bs-danger)',
                      'border-radius': '5px',
                      'margin-bottom': '1rem',
                      'display': 'inline-block',
                      'text-align': 'center',
                      'color': 'var(--bs-light)',
                      'background': 'var(--bs-danger)',
                      'font-size': 'smaller',
                    },
                  };
                }
              } else {
                return {
                  value: '',
                  type: 'approve',
                  title: 'Approve',
                  icon: 'fa-solid fa-check text-success md-font-size',
                  role: 'button',
                };
              }
            },
          },
          {
            role: 'button',
            condition: function (row: any) {
              const approved =
                row?.additional_info?.clock_report?.status == 'approved';
              const rejected =
                row?.additional_info?.clock_report?.status == 'rejected';
              if (approved || rejected) {
                return false;
              }
              return {
                value: '',
                type: 'reject',
                title: 'Reject',
                icon: 'fa-solid fa-xmark text-danger md-font-size ms-2',
              };
            },
          },
          {
            condition: function (row: any) {
              const approved =
                row?.additional_info?.clock_report?.status == 'approved';
              const rejected =
                row?.additional_info?.clock_report?.status == 'rejected';

              if (approved || rejected) {
                return {
                  value: '',
                  type: 'accept_reject',
                  title: 'Accept/ Reject',
                  icon: 'fa-solid fa-ellipsis-vertical md-font-size ms-2',
                };
              } else {
                return false;
              }
            },
          },
        ],
      },
      {
        header: '',
        showAction: true,

        actionOptions: [
          {
            role: 'button',

            condition: function (row: any) {
              return {
                value: '',
                type: 'show_details',
                title: 'Show Details',
                icon: 'fa-solid fa-ellipsis md-font-size ms-2',
              };
            },
          },
        ],
      },
    ];
  }
  getOnlyDateFromDateObj = (date: any) => {
    const dateObj = new Date(date);
    dateObj.setHours(0, 0, 0, 0);
    return dateObj.getTime();
  };
  getDateTimeWithSameDayCheck(eventDay: any, eventDateTime: any) {
    const isSameDay = eventDay === this.getOnlyDateFromDateObj(eventDateTime);
    if (isSameDay) return formatDateTimeStamp(eventDateTime, 'HH:mm', 'en_US');
    return formatDateTimeStamp(eventDateTime, 'HH:mm EEE d MMM y', 'en_US');
  }
  searchUsers(event: any) {
    const searchStr = event?.target?.value || '';

    if (searchStr?.length < 2) return;
    this.onSearchUsers(searchStr);
  }
  onSearchUsers(searchStr?: any) {
    this.jobService
      .getUserList({
        search_str: searchStr || '',
      })
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.userLookupDataList = response.data || [];
          if (!searchStr)
            this.initialDataList['user'] = JSON.parse(
              JSON.stringify(this.userLookupDataList),
            );
        }
      });
  }
  onSelectUser(userData: any) {
    this.selectedUser = userData;
    this.previousClockInOutTimeSheet = 0;
    this.pageNumClockInOutTimeSheet = 1;

    this.getAllClockInOutReportData();
  }
  onShiftSearch(event?: any) {
    const searchStr = event?.target?.value || '';

    let reqBody: any = {
      rows: 30,
      date_range: this.getWeekDateRangeDict(),
    };
    if (this.selectedJobType?.id) {
      reqBody['job_type_id'] = this.getPayloadJobTypeId();
    }

    if (searchStr) {
      reqBody['timesheet_search_params'] = { shift_name__icontains: searchStr };
    }
    if (this.selectedUser?.id) {
      reqBody['sub_user_id'] = this.selectedUser?.id;
    }
    this.userService
      .modfiyTimeAttendanceReport(reqBody, { lookup_shift: 1 })

      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.shiftLookupDataList = response.data || [];
          if (!searchStr)
            this.initialDataList['shift'] = JSON.parse(
              JSON.stringify(this.shiftLookupDataList),
            );
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
          this.spinnerService.hide();
        }
      });
  }

  onSelectShift(shiftData: any) {
    this.shiftSearchString = shiftData?.shift_name || '';
    this.previousClockInOutTimeSheet = 0;
    this.pageNumClockInOutTimeSheet = 1;

    this.getAllClockInOutReportData();
  }
  getPayloadJobTypeId() {
    return [4, 6].includes(this.selectedJobType?.type_identity)
      ? this.selectedJobType?.type_identity
      : this.selectedJobType?.id;
  }
  onSelectJobType(event: any) {
    this.selectedJobType = this.availableJobTypes?.find(
      (item: any) => item?.id == event.target.value,
    );

    this.previousClockInOutTimeSheet = 0;
    this.pageNumClockInOutTimeSheet = 1;

    this.getAllClockInOutReportData();
  }
  editField(field: string) {
    if (field == 'user') {
      this.shiftFocus('userLookupFieldId');
    }
    if (field == 'shift') {
      this.shiftFocus('shiftLookupFieldId');
    }
  }

  shiftFocus(elementId: string) {
    setTimeout(() => {
      var element = <HTMLInputElement>document.getElementById(elementId);
      element?.focus();
    }, 200);
  }
  inputFocused(field: 'user' | 'shift') {
    if (field === 'user') {
      this.selectedUser = {};
    }

    this.updateInitialDataList(field);
  }
  updateInitialDataList(field: 'user' | 'shift') {
    this.userLookupDataList = [];
    setTimeout(() => {
      if (field === 'user') {
        this.userLookupDataList = JSON.parse(
          JSON.stringify(this.initialDataList?.[field] || []),
        );
      }

      if (field === 'shift') {
        const shiftDataLookupBackup = JSON.parse(
          JSON.stringify(this.initialDataList?.[field] || []),
        );

        // if (shiftDataLookupBackup?.length) {
        this.shiftLookupDataList = shiftDataLookupBackup;
        // } else {
        //   this.onShiftSearch('');
        // }
      }
    }, 200);
  }
  dateTimeCheck(data: any) {
    const newTime = new Date(data.newValue).getTime();
    const oldTime = new Date(data.oldValue).getTime();

    data.valueChanged = false;
    if (newTime != oldTime) {
      data.valueChanged = true;
      const isClockIn = data?.clock_in_id;
      if (isClockIn) {
        const startTime = new Date(data?.start_datetime).getTime();
        data.updated_clocked_in_event_action = newTime > startTime ? 5 : 0;
      } else {
        const endTime = new Date(data?.end_datetime).getTime();
        data.updated_clocked_out_event_action = newTime < endTime ? 4 : 1;
      }
    }
  }
}
